var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-section" },
    [
      _c(
        "emd-card",
        { staticClass: "_footer_spaced_sm", attrs: { noBorder: "" } },
        [
          _vm._t("header"),
          _vm._t("default"),
          _vm.loadingListOrders
            ? _c(
                "section",
                { staticClass: "eu-pa_6 eu-align_center" },
                [_c("emd-loader", { attrs: { type: "_invert" } })],
                1
              )
            : _c(
                "section",
                { staticClass: "emd-table-responsive" },
                [
                  _c("Table", {
                    attrs: {
                      fields: _vm.fields,
                      items: _vm.items,
                      toDetail: _vm.detail,
                    },
                  }),
                  _vm.showEmptyList
                    ? _c("empty-list", { attrs: { entity: "orders" } })
                    : _vm._e(),
                  _vm.showEmptyListFilter
                    ? _c("empty-list-filter", { attrs: { entity: "orders" } })
                    : _vm._e(),
                ],
                1
              ),
          !_vm.loadingListOrders
            ? _c("pagination", {
                attrs: {
                  type: "list",
                  action: _vm.action,
                  pagination: _vm.pagination,
                  totalShowing: _vm.totalItems,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }